module.exports = __webpack_public_path__ + "img/34.85adc8f7.png";